import React from "react";

import Toast from "./toast";
import Modal from "./modal";
import Auth from "./auth";
import Player from "./player";
import Socket from "./socket";
import Redirect from "./redirect";
import UI from "./ui";

export default () => {
  return (
    <>
      <Toast />
      <Auth />
      <Player />
      <Modal />
      <Socket />
      <Redirect />
      <UI />
    </>
  );
};
